import { NewDate } from '@/Domain/News'
import { HeavyTickets } from '.'

export class Execution {
  private _modoAlleamento: string
  private _dataLicenciaCorta: NewDate | null
  private _dataActaEntrega: NewDate | null
  private _prazoDefinitivo: number
  private _dataPrevistaRemate: NewDate | null
  private _solicitudeProrroga: boolean
  private _prazoSolicitude: number
  private _dataLimiteCorta: NewDate | null
  private _resolucion: string
  private _dataResolucion: NewDate | null
  private _dataAmplicacionprazo: NewDate | null
  private _observaciones: string
  private _balance: number | null
  private _heavyTickets: HeavyTickets

  constructor (
    modoAlleamento: string,
    dataLicenciaCorta: NewDate | null,
    dataActaEntrega: NewDate | null,
    prazoDefinitivo: number,
    dataPrevistaRemate: NewDate | null,
    solicitudeProrroga: boolean,
    prazoSolicitude: number,
    dataLimiteCorta: NewDate | null,
    resolucion: string,
    dataResolucion: NewDate | null,
    dataAmplicacionprazo: NewDate | null,
    observaciones: string,
    balance: number | null,
    heavyTickets: HeavyTickets
  ) {
    this._modoAlleamento = modoAlleamento
    this._dataLicenciaCorta = dataLicenciaCorta
    this._dataActaEntrega = dataActaEntrega
    this._prazoDefinitivo = prazoDefinitivo
    this._dataPrevistaRemate = dataPrevistaRemate
    this._solicitudeProrroga = solicitudeProrroga
    this._prazoSolicitude = prazoSolicitude
    this._dataLimiteCorta = dataLimiteCorta
    this._resolucion = resolucion
    this._dataResolucion = dataResolucion
    this._dataAmplicacionprazo = dataAmplicacionprazo
    this._observaciones = observaciones
    this._balance = balance
    this._heavyTickets = heavyTickets
  }

  get modoAlleamento (): string {
    return this._modoAlleamento
  }

  get dataLicenciaCorta (): string {
    if (this._dataLicenciaCorta !== null) {
      return this._dataLicenciaCorta.date()
    } else { return '' }
  }

  get dataActaEntrega (): string {
    if (this._dataActaEntrega !== null) {
      return this._dataActaEntrega.date()
    } else { return '' }
  }

  get prazoDefinitivo (): number {
    return this._prazoDefinitivo
  }

  get dataPrevistaRemate (): string {
    if (this._dataPrevistaRemate !== null) {
      return this._dataPrevistaRemate.date()
    } else { return '' }
  }

  get solicitudeProrroga (): boolean {
    return this._solicitudeProrroga
  }

  get prazoSolicitude (): number {
    return this._prazoSolicitude
  }

  get dataLimiteCorta (): string {
    if (this._dataLimiteCorta !== null) {
      return this._dataLimiteCorta.date()
    } else { return '' }
  }

  get resolucion (): string {
    return this._resolucion
  }

  get dataResolucion (): string {
    if (this._dataResolucion !== null) {
      return this._dataResolucion.date()
    } else { return '' }
  }

  get dataAmplicacionprazo (): string {
    if (this._dataAmplicacionprazo !== null) {
      return this._dataAmplicacionprazo.date()
    } else { return '' }
  }

  get observaciones (): string {
    return this._observaciones
  }

  get balance (): number {
    if (this._balance !== null) {
      return this._balance
    } else { return 0 }
  }

  getHeavyTickets (): HeavyTickets {
    return this._heavyTickets
  }
}
